import React from "react";
import styled from "styled-components";

const CardWrapper = styled.div`
  @media (min-width: 768px) {
    width: 100%;
    margin: auto;
  }
`;

const CardContainer = styled.div`
  background-color: white;
  border-radius: 20px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column; /* Default to column for mobile */
  padding: 24px;
  gap: 24px;

  @media (min-width: 768px) {
    flex-direction: row; /* Row layout for larger screens */
  }
`;

const InfoContainer = styled.div`
  flex: 1;
`;

const Heading = styled.h1`
  font-size: 1.5rem;
  font-weight: bold;
  color: #4a5568;
  margin-bottom: 16px;
`;

const Text = styled.p`
  color: #4a5568;
  font-size: 1rem;
  margin-bottom: 16px;
`;

const BoldText = styled.span`
  font-weight: 600;
`;

const MapContainer = styled.div`
  flex: 1;
  height: 300px;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 24px; /* For mobile, we want the map to come first */

  @media (min-width: 768px) {
    margin-bottom: 0; /* Remove margin for larger screens */
  }
`;

const WhatsAppLink = styled.a`
  display: inline-block;
  margin-top: 16px;
  color: #25d366;
  font-size: 1.1rem;
  font-weight: bold;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const CallLink = styled.a`
  display: inline-block;
  margin-top: 16px;
  color: #1d72b8;
  font-size: 1.1rem;
  font-weight: bold;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const EmailLink = styled.a`
  display: inline-block;
  margin-top: 16px;
  color: #d14836;
  font-size: 1.1rem;
  font-weight: bold;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const TraviatorHolidaysCard = ({ mapLink, address, name, mobile, email, whatsapp }) => {
  const whatsappLink = "https://wa.me/+91" + whatsapp;
  const phoneLink = "tel:+91" + mobile;
  return (
    <CardWrapper>
      <CardContainer>
        <MapContainer>
          <iframe
            src={mapLink} // Use the generated Embed URL here
            width="100%"
            height="100%"
            frameBorder="0"
            style={{ border: "0" }}
            allowFullScreen=""
            aria-hidden="false"
            tabIndex="0"
          ></iframe>
        </MapContainer>
        <InfoContainer>
          <Heading>Traviator Holidays</Heading>
          <div>
            <Text>
              <BoldText>Office Address:</BoldText> {address}
            </Text>
          </div>
          <div>
            <Text>
              <BoldText>Registered Address:</BoldText> {"Plot No. T-9, Govindpuri, Modinagar, Uttar Pradesh - 201204, India"}
            </Text>
          </div>
          <div>
            <Text>
              <BoldText>Contact Person:</BoldText> {name}
            </Text>
          </div>
          <div>
            <Text>
              <BoldText>Mobile:</BoldText> {mobile}
            </Text>
          </div>
          <div>
            <Text>
              <BoldText>Email:</BoldText> {email}
            </Text>
          </div>
          <WhatsAppLink href={whatsappLink} target="_blank" rel="noopener noreferrer">
            Chat with us on WhatsApp |
          </WhatsAppLink>
          <CallLink href={phoneLink}>
            | Call Us
          </CallLink>
        </InfoContainer>
      </CardContainer>
    </CardWrapper>
  );
};

export default TraviatorHolidaysCard;
